import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";
import "./WriteUsForm.css";

const WriteUsForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    number: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required.";
    }
    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
      newErrors.email = "Invalid email format.";
    }
    if (!formData.number.trim()) {
      newErrors.number = "Mobile number is required.";
    } else if (!/^(\+91|91|0)?[6-9]\d{9}$/.test(formData.number)) {
      newErrors.number = "Enter a valid Indian mobile number.";
    }
    if (!formData.message.trim()) {
      newErrors.message = "Message cannot be empty.";
    }

    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = validateForm();

    if (Object.keys(newErrors).length === 0) {
      alert("Form submitted successfully!");
      setFormData({
        name: "",
        email: "",
        message: "",
        number: "",
      });
      setErrors({});
    } else {
      setErrors(newErrors);
    }
  };

  return (
    <div className="write-us-card p-4 rounded">
      <div className="content">
        <h3 style={{fontSize:'40px'}}><b>Or Write Us</b></h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group mb-3">
            <label htmlFor="name">Name *</label>
            <input
              type="text"
              id="name"
              name="name"
              className="form-control"
              placeholder="Enter your name"
              value={formData.name}
              onChange={handleChange}
            />
            {errors.name && <small className="text-danger">{errors.name}</small>}
          </div>
          <div className="form-group mb-3">
            <label htmlFor="email">Email *</label>
            <input
              type="email"
              id="email"
              name="email"
              className="form-control"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
            />
            {errors.email && <small className="text-danger">{errors.email}</small>}
          </div>
          <div className="form-group mb-3">
            <label htmlFor="number">Mobile Number *</label>
            <input
              type="text"
              id="number"
              name="number"
              className="form-control"
              placeholder="Enter your mobile number"
              value={formData.number}
              onChange={handleChange}
            />
            {errors.number && <small className="text-danger">{errors.number}</small>}
          </div>
          <div className="form-group mb-3">
            <label htmlFor="message">Enter Your Message *</label>
            <textarea
              id="message"
              name="message"
              className="form-control"
              rows="4"
              placeholder="Write your message"
              value={formData.message}
              onChange={handleChange}
            ></textarea>
            {errors.message && <small className="text-danger">{errors.message}</small>}
          </div>
          <button type="submit" className="btn btn-primary" style={{backgroundColor:'#052f5f'}}>
            Send Message
          </button>
        </form>
        {/* Social Icons Section */}
        <div className="social-icons d-flex justify-content-center mt-3">
          <a href="#" className="icon d-flex align-items-center justify-content-center mx-2" style={{border:'2px solid gray',borderRadius:'50px'}}>
            <i className="fab fa-facebook"></i>
          </a>
          <a href="#" className="icon d-flex align-items-center justify-content-center mx-2"style={{border:'2px solid gray',borderRadius:'50px'}}>
            <i className="fab fa-twitter"></i>
          </a>
          <a href="#" className="icon d-flex align-items-center justify-content-center mx-2"style={{border:'2px solid gray',borderRadius:'50px'}}>
            <i className="fab fa-instagram"></i>
          </a>
          <a href="#" className="icon d-flex align-items-center justify-content-center mx-2"style={{border:'2px solid gray',borderRadius:'50px'}}>
            <i className="fab fa-whatsapp"></i>
          </a>
        </div>
      </div>
    </div>
  );
};

export default WriteUsForm;
